import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "@mui/material";
import { AppColors } from "../util/AppColors";

/**
 * Info icon with tooltip. Safe next to labels; blocks mouse-down so fields don't steal focus.
 */
const FieldInfoIcon = ({ text, sx = {} }) => {
  if (!text) return null;
  return (
    <Tooltip
      title={text}
      arrow
      placement="top"
      enterTouchDelay={0}
      describeChild
    >
      <InfoOutlinedIcon
        tabIndex={0}
        onMouseDown={(e) => e.preventDefault()}
        onClick={(e) => e.stopPropagation()}
        sx={{
          fontSize: 14,
          ml: 0.5,
          color: AppColors.gray3,
          cursor: "help",
          verticalAlign: "middle",
          flexShrink: 0,
          outline: "none",
          ...sx,
        }}
      />
    </Tooltip>
  );
};

/** Label + optional help icon — pass as MUI / CustomTextField / Select `label`. */
export const FieldHelpLabel = ({ label, infoText }) => {
  if (!infoText) return label;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        maxWidth: "100%",
      }}
    >
      <span>{label}</span>
      <FieldInfoIcon text={infoText} />
    </span>
  );
};

export default FieldInfoIcon;
